<template>
    <div>
        <section>
            <div class="inner row5 resultDetailInner">
                <div class="resultDetailTop">
                    <div class="left">
                        <VueSlickCarousel v-bind="settings">
                            <div class="imgBox">
                                <div class="imgBoxOverlay"></div>
                                <img src="../../assets/images/cmmnMain/고령소비자서비스이미지.png" class="productDetailImg" alt="">
                            </div>
                            <div class="imgBox">
                                <div class="imgBoxOverlay"></div>
                                <img src="../../assets/images/cmmnMain/고령소비자서비스이미지.png" class="productDetailImg" alt="">
                            </div>
                            <div class="imgBox">
                                <div class="imgBoxOverlay"></div>
                                <img src="../../assets/images/cmmnMain/고령소비자서비스이미지.png" class="productDetailImg" alt="">
                            </div>
                            <div class="imgBox">
                                <div class="imgBoxOverlay"></div>
                                <img src="../../assets/images/cmmnMain/고령소비자서비스이미지.png" class="productDetailImg" alt="">
                            </div>
                        </VueSlickCarousel>
                    </div>
                    <div class="right">
                        <div class="title">
                            <h1>제품명</h1>
                            <h4>제품 설명</h4>
                            <div>
                                <p>123123</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="resultDetailbody">
                    <div class="productInfo">
                        <h1 class="mainTitle">제품 정보</h1>
                        <div class="contentsbody">
                            <div class="left">
                                <div class="productInfoItem">
                                    <p>제조구분</p>
                                    <div class="productInfoItemcontent">
                                        123
                                    </div>
                                </div>

                                <div class="productInfoItem">
                                    <p>업체명</p>
                                    <div class="productInfoItemcontent">
                                        123
                                    </div>
                                </div>

                                <div class="productInfoItem">
                                    <p>제품명</p>
                                    <div class="productInfoItemcontent">
                                        123
                                    </div>
                                </div>

                                <div class="productInfoItem">
                                    <p>가격</p>
                                    <div class="productInfoItemcontent">
                                        123
                                    </div>
                                </div>

                                <div class="productInfoItem">
                                    <p>제품링크</p>
                                    <div class="productInfoItemcontent">
                                        123
                                    </div>
                                </div>
                            </div>
                            <div class="right">
                                <ul>
                                    <li>
                                        <div class="productInfoListTitle">
                                            <p>항목 1</p>
                                        </div>
                                        <div class="productInfoList">
                                            <p>123</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="productInfoListTitle">
                                            <p>항목 2</p>
                                        </div>
                                        <div class="productInfoList">
                                            <p>123</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="productInfoListTitle">
                                            <p>항목 3</p>
                                        </div>
                                        <div class="productInfoList">
                                            <p>123</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="productInfoListTitle">
                                            <p>항목 4</p>
                                        </div>
                                        <div class="productInfoList">
                                            <p>123</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="productInfoListTitle">
                                            <p>항목 5</p>
                                        </div>
                                        <div class="productInfoList">
                                            <p>123</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="productInfoListTitle">
                                            <p>항목 6</p>
                                        </div>
                                        <div class="productInfoList">
                                            <p>123</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="productInfoListTitle">
                                            <p>항목 7</p>
                                        </div>
                                        <div class="productInfoList">
                                            <p>123</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="productInfoListTitle">
                                            <p>항목 8</p>
                                        </div>
                                        <div class="productInfoList">
                                            <p>123</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="productInfoListTitle">
                                            <p>항목 9</p>
                                        </div>
                                        <div class="productInfoList">
                                            <p>123</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="productInfoListTitle">
                                            <p>항목 10</p>
                                        </div>
                                        <div class="productInfoList">
                                            <p>123</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="productDetailDec">
                        <h1 class="mainTitle">상세설명</h1>
                        <div class="productDetailDecEdit">
                            editer 영역
                        </div>
                    </div>

                    <div class="corpInfo">
                        <h1 class="mainTitle">기업 정보</h1>
                        <div class="corpInfoTable">
                            <table border="1" border-collapse:>
                                <tbody>
                                    <tr>
                                        <th>
                                            기업명
                                        </th>
                                        <td>
                                            주식회사 OOO
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            업종
                                        </th>
                                        <td>
                                            전기전자
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            설립연도
                                        </th>
                                        <td>
                                            2021.06.09
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            기업형태
                                        </th>
                                        <td>
                                            중소기업
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            대표자
                                        </th>
                                        <td>
                                            홍길동
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            주소
                                        </th>
                                        <td>
                                            대전광역시 유성구 관편동 000번지
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            대표 번호
                                        </th>
                                        <td>
                                            010-1324-5678
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            홈페이지
                                        </th>
                                        <td>
                                            https://naver.com
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="resultListBtnBox">
                        <router-link class="mainBgBtn startBtnFont" to="/serviceSearch">목 록</router-link>
                    </div>
                </div>
            </div>
        </section>
        
    </div>   
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    name: 'ServiceSearchDetail',
    components: {
        VueSlickCarousel 
    },
    computed: {
        
    },
    data(){
        return {
            settings: {
                dots:true,
                arrows:false,
                fade:false,
                speed:1500,
                infinite:true,
                autoplay:false,
                autoplaySpeed:5000,
                pauseOnDotsHover:true,
                swipeToSlide: true,
                "responsive": [
                    {
                    "breakpoint": 560,
                    "settings": {
                        "slidesToShow": 1,
                        "slidesToScroll": 1,
                    }
                    },
                ]
            }
        }
    },
    methods:{
        
    },
}

</script>

<style scoped>
    a {
        color: #272727;
    }
    h3 {
        margin: 0 0 16px 0;
    }
    
</style>

<style>
</style>

